// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/admin";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  privacy: "/privacy-policy",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  notification: path(ROOTS_DASHBOARD, "/notification"),
  profile: path(ROOTS_DASHBOARD, "/profile"),
  search: path(ROOTS_DASHBOARD, "/search"),

  news: {
    root: path(ROOTS_DASHBOARD, "/news"),
    list: path(ROOTS_DASHBOARD, "/news/list"),
    categories: path(ROOTS_DASHBOARD, "/news/categories"),
    add: path(ROOTS_DASHBOARD, "/news/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/news/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/news/view/${id}`),
  },

  // TODO: done by saroj

  feature: {
    root: path(ROOTS_DASHBOARD, "/features"),
    list: path(ROOTS_DASHBOARD, "/features/list"),
    add: path(ROOTS_DASHBOARD, "/features/add"),
    categories: path(ROOTS_DASHBOARD, "/features/categories"),
    edit: (id) => path(ROOTS_DASHBOARD, `/features/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/features/view/${id}`),
  },

  banner: {
    root: path(ROOTS_DASHBOARD, "/banners"),
    list: path(ROOTS_DASHBOARD, "/banners/list"),
    add: path(ROOTS_DASHBOARD, "/banners/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/banners/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/banners/view/${id}`),
  },

  sponsors: {
    root: path(ROOTS_DASHBOARD, "/sponsors"),
    list: path(ROOTS_DASHBOARD, "/sponsors/list"),
    add: path(ROOTS_DASHBOARD, "/sponsors/add"),
    categories: path(ROOTS_DASHBOARD, "/sponsors/categories"),
    edit: (id) => path(ROOTS_DASHBOARD, `/sponsors/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/sponsors/view/${id}`),
  },

  admins: {
    root: path(ROOTS_DASHBOARD, "/user-management"),
    list: path(ROOTS_DASHBOARD, "/user-management/list"),
    add: path(ROOTS_DASHBOARD, "/user-management/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/user-management/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/user-management/view/${id}`),
  },

  // TODO: nkl settings
  settings: {
    root: path(ROOTS_DASHBOARD, "/settings"),
    seasons: {
      root: path(ROOTS_DASHBOARD, "/settings/seasons"),
      list: path(ROOTS_DASHBOARD, "/settings/seasons/list"),
      add: path(ROOTS_DASHBOARD, "/settings/seasons/add"),
      detail: (id) => path(ROOTS_DASHBOARD, `/settings/seasons/detail/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/settings/seasons/view/${id}`),
    },

    champions: {
      root: path(ROOTS_DASHBOARD, "/settings/champions"),
      list: path(ROOTS_DASHBOARD, "/settings/champions/list"),
      add: path(ROOTS_DASHBOARD, "/settings/champions/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/settings/champions/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/settings/champions/view/${id}`),
    },

    stadiums: {
      root: path(ROOTS_DASHBOARD, "/settings/stadiums"),
      list: path(ROOTS_DASHBOARD, "/settings/stadiums/list"),
      add: path(ROOTS_DASHBOARD, "/settings/stadiums/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/settings/stadiums/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/settings/stadiums/view/${id}`),
    },

    keypersons: {
      root: path(ROOTS_DASHBOARD, "/settings/keypersons"),
      list: path(ROOTS_DASHBOARD, "/settings/keypersons/list"),
      add: path(ROOTS_DASHBOARD, "/settings/keypersons/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/settings/keypersons/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/settings/keypersons/view/${id}`),
    },

    positions: {
      root: path(ROOTS_DASHBOARD, "/settings/positions"),
      list: path(ROOTS_DASHBOARD, "/settings/positions/list"),
      add: path(ROOTS_DASHBOARD, "/settings/positions/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/settings/positions/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/settings/positions/view/${id}`),
    },
  },

  games: {
    root: path(ROOTS_DASHBOARD, "/games"),
    list: path(ROOTS_DASHBOARD, "/games/list"),
    add: path(ROOTS_DASHBOARD, "/games/add"),
    lineups: (id, season_id) =>
      path(ROOTS_DASHBOARD, `/games/lineup/${id}?season_id=${season_id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/games/edit/${id}`),
    view: (id, season_id) =>
      path(ROOTS_DASHBOARD, `/games/view/${id}?season_id=${season_id}`),
    fanvoice: (id, season_id) =>
      path(ROOTS_DASHBOARD, `/games/fan-voice/${id}?season_id=${season_id}`),
    fanvoiceedit: (id) => path(ROOTS_DASHBOARD, `/games/fan-voice/edit/${id}`),
  },

  fanChoice: {
    root: path(ROOTS_DASHBOARD, "/fan-choice"),
    list: path(ROOTS_DASHBOARD, "/fan-choice/list"),
    add: path(ROOTS_DASHBOARD, "/fan-choice/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/fan-choice/edit/${id}`),
  },

  teams: {
    root: path(ROOTS_DASHBOARD, "/teams"),
    list: path(ROOTS_DASHBOARD, "/teams/list"),
    add: path(ROOTS_DASHBOARD, "/teams/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/teams/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/teams/view/${id}`),
    addsquad: (id, season_id) =>
      path(ROOTS_DASHBOARD, `/teams/add-squad/${id}?season_id=${season_id}`),
    teamsquad: (id) => path(ROOTS_DASHBOARD, `/teams/squad/${id}`),
    editsquad: (id, season_id) =>
      path(ROOTS_DASHBOARD, `/teams/edit-squad/${id}?season_id=${season_id}`),
  },

  // -================

  progress: {
    root: path(ROOTS_DASHBOARD, "/progress"),
    list: path(ROOTS_DASHBOARD, "/progress/list"),
    payment: path(ROOTS_DASHBOARD, "/progress/payment"),
    details: path(ROOTS_DASHBOARD, "/progress/details"),
  },
  completed: {
    root: path(ROOTS_DASHBOARD, "/completed"),
    list: path(ROOTS_DASHBOARD, "/completed/list"),
    payment: path(ROOTS_DASHBOARD, "/completed/payment"),
  },
  assign: path(ROOTS_DASHBOARD, "/assign"),
  ratings: path(ROOTS_DASHBOARD, "/ratings"),
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    add: path(ROOTS_DASHBOARD, "/user/add"),
  },
  videohub: {
    root: path(ROOTS_DASHBOARD, "/videohub"),
    list: path(ROOTS_DASHBOARD, "/videohub/list"),
    add: path(ROOTS_DASHBOARD, "/videohub/add"),
    categories: path(ROOTS_DASHBOARD, "/videohub/categories"),
    view: (id) => path(ROOTS_DASHBOARD, `/videohub/view/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/videohub/edit/${id}`),
  },

  photo: {
    root: path(ROOTS_DASHBOARD, "/photo"),
    list: path(ROOTS_DASHBOARD, "/photo/list"),
    add: path(ROOTS_DASHBOARD, "/photo/add"),
    categories: path(ROOTS_DASHBOARD, "/photo/categories"),
    view: (id) => path(ROOTS_DASHBOARD, `/photo/view/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/photo/edit/${id}`),
  },

  testimonials: {
    root: path(ROOTS_DASHBOARD, "/testimonials"),
    list: path(ROOTS_DASHBOARD, "/testimonials/list"),
    create: path(ROOTS_DASHBOARD, "/testimonials/create"),
    view: (id) => path(ROOTS_DASHBOARD, `/testimonials/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/testimonials/edit/${id}`),
  },

  contact: {
    root: path(ROOTS_DASHBOARD, "/contact"),
    list: path(ROOTS_DASHBOARD, "/contact/list"),
    create: path(ROOTS_DASHBOARD, "/contact/create"),
    view: (id) => path(ROOTS_DASHBOARD, `/contact/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/contact/edit/${id}`),
  },
  verified: {
    root: path(ROOTS_DASHBOARD, "/verified"),
    players: {
      root: path(ROOTS_DASHBOARD, "/verified/player"),
      list: path(ROOTS_DASHBOARD, "/verified/player/list"),
      add: path(ROOTS_DASHBOARD, "/verified/player/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/verified/player/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/verified/player/view/${id}`),
    },

    coach: {
      root: path(ROOTS_DASHBOARD, "/verified/coach"),
      list: path(ROOTS_DASHBOARD, "/verified/coach/list"),
      add: path(ROOTS_DASHBOARD, "/verified/coach/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/verified/coach/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/verified/coach/view/${id}`),
    },
  },

  registrations: {
    root: path(ROOTS_DASHBOARD, "/registration"),
    players: {
      root: path(ROOTS_DASHBOARD, "/registration/player"),
      list: path(ROOTS_DASHBOARD, "/registration/player/list"),
      add: path(ROOTS_DASHBOARD, "/registration/player/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/registration/player/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/registration/player/view/${id}`),
    },

    coach: {
      root: path(ROOTS_DASHBOARD, "/registration/coach"),
      list: path(ROOTS_DASHBOARD, "/registration/coach/list"),
      add: path(ROOTS_DASHBOARD, "/registration/coach/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/registration/coach/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/registration/coach/view/${id}`),
    },

    technical: {
      root: path(ROOTS_DASHBOARD, "/registration/technical"),
      list: path(ROOTS_DASHBOARD, "/registration/technical/list"),
      add: path(ROOTS_DASHBOARD, "/registration/technical/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/registration/technical/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/registration/technical/view/${id}`),
    },

    users: {
      root: path(ROOTS_DASHBOARD, "/registration/users"),
      list: path(ROOTS_DASHBOARD, "/registration/users/list"),
      add: path(ROOTS_DASHBOARD, "/registration/users/add"),
    },
  },

  role: {
    root: path(ROOTS_DASHBOARD, "/role"),
    list: path(ROOTS_DASHBOARD, "/role/list"),
    add: path(ROOTS_DASHBOARD, "/role/add"),
  },
  coupon: {
    root: path(ROOTS_DASHBOARD, "/coupon"),
    list: path(ROOTS_DASHBOARD, "/coupon/list"),
    add: path(ROOTS_DASHBOARD, "/coupon/add"),
  },

  logs: {
    root: path(ROOTS_DASHBOARD, "/logs"),
    customer: path(ROOTS_DASHBOARD, "/logs/customer"),
    driver: path(ROOTS_DASHBOARD, "/logs/driver"),
  },
  rates: {
    root: path(ROOTS_DASHBOARD, "/rates"),
    list: path(ROOTS_DASHBOARD, "/rates/list"),
    addrate: path(ROOTS_DASHBOARD, "/rates/add-rates"),
    taxation: path(ROOTS_DASHBOARD, "/rates/taxation"),
    addtax: path(ROOTS_DASHBOARD, "/rates/add-taxation"),
    additional: path(ROOTS_DASHBOARD, "/rates/additional-charges"),
    addadditional: path(ROOTS_DASHBOARD, "/rates/add-additional-charges"),
    daytimes: path(ROOTS_DASHBOARD, "/rates/day-times"),
    adddaytimes: path(ROOTS_DASHBOARD, "/rates/add-day-times"),
  },
  cancel: {
    root: path(ROOTS_DASHBOARD, "/cancel-reasons"),
    list: path(ROOTS_DASHBOARD, "/cancel-reasons/list"),
    add: path(ROOTS_DASHBOARD, "/cancel-reasons/add"),
  },
  policyType: {
    root: path(ROOTS_DASHBOARD, "/policy-type"),
    list: path(ROOTS_DASHBOARD, "/policy-type/list"),
    add: path(ROOTS_DASHBOARD, "/policy-type/add"),
  },
  tripHours: {
    root: path(ROOTS_DASHBOARD, "/trip-hours"),
    list: path(ROOTS_DASHBOARD, "/trip-hours/list"),
    add: path(ROOTS_DASHBOARD, "/trip-hours/add"),
  },
  vehicle: {
    root: path(ROOTS_DASHBOARD, "/vehicle"),
    vehicle_type_list: path(ROOTS_DASHBOARD, "/vehicle/vehicle-type/list"),
    vehicle_model_list: path(ROOTS_DASHBOARD, "/vehicle/vehicle-model/list"),
    transmission_type_list: path(
      ROOTS_DASHBOARD,
      "/vehicle/transmission-type/list"
    ),
  },

  tripStatus: {
    root: path(ROOTS_DASHBOARD, "/trip-status"),
    list: path(ROOTS_DASHBOARD, "/trip-status/list"),
    add: path(ROOTS_DASHBOARD, "/trip-status/add"),
  },

  manage: {
    root: path(ROOTS_DASHBOARD, "/manage"),
    privacy: path(ROOTS_DASHBOARD, "/manage/policy"),
    addprivacy: path(ROOTS_DASHBOARD, "/manage/add-policy"),

    terms: path(ROOTS_DASHBOARD, "/manage/terms-conditions"),
    faqs: path(ROOTS_DASHBOARD, "/manage/faqs"),
    addfaqs: path(ROOTS_DASHBOARD, "/manage/add-faqs"),
    contact: path(ROOTS_DASHBOARD, "/manage/contact"),
  },
};
